import React, { Component } from 'react';
import { switchModule, setOptions } from '../../../actions/display';
import { connect } from 'react-redux';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import shared from '../../../utils/shared.js';
import MenuSeattle from './MenuSeattle';
import ContentSeattle from './ContentSeattle';
import IdleLoop from '../../../containers/IdleLoop';
import _ from 'lodash';
import CheckerboardSeattle from './CheckerboardSeattle';
import TouchGestureSeattle from './TouchGestureSeattle';
import { Switch, Route } from 'react-router-dom';

// const TOUCH_START_BUBBLE_DIAMETER = 8.77;
const STAGE_ONE_LOCKED = "stage_one_locked";
const STAGE_TWO_LOCKED = "stage_two_locked";
const RELEASED = "released";

class SeattleContainer extends Component {
  constructor(props) {
    super(props);
    window.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    this._screensNumber = this.getScreensNumber();
    this._menuActive = false;
    this._idleLoopTimeout = null;
    this.idleRef = 0;
    this._xScreens = this.props.displayLayout.horizontal;
    this._yScreens = this.props.displayLayout.vertical;
    this._startButtonRef = null;
    this._touchToStartTextRef = null;
    this._handIconRef = null;
    this._swipeAnimationTimerHandler = null;
    this._clickLocked = RELEASED;
    this._attractLoopTree = {};
    this._isSwipeAnimationActive = true;
    this._swipeTimeout = 5000;

    let regionWidth = this.props.screen.screenWidth / this._xScreens;
    this._menuOriginalCoordinates = {
      x: 7.5 / 100 * regionWidth, // based on % of total width
      y: 11.25 / 100 * regionWidth // based on % of total height
    }

    let initialImage = this.getBackground(null);
    this.setupElements();
    this.state = {
      idle: false,
      showNavButton: false,
      module: null,
      showDebug: false,
      menuOnScreen: false,
      menuActive: this._menuActive,
      regionChanged: false,
      attractLoopBackground: null,
      buttonPressed: false,
      content: null,
      background: initialImage,
      activateBubble: false,
      activateListMenu: false,
      showGesture: false
    };
  }

  componentWillMount() {
    this.setupElements();
    let topAttractLoop = _.filter(this.props.content.story_categories, { parent_category: null, contents: { custom_fields: { folder_type: { val: { value: "attract_loop" } } } } });
    let allDonors = shared.getAllDonors(this.props.donors);
    this._allDonors = allDonors;
    if (topAttractLoop && topAttractLoop[0]) {
      this._attractLoopTree = shared.createFolderTree(this.props.content.story_categories, this.props.content.folder_modules, null, this.props.content.stories, this.props.content.dm_active, topAttractLoop[0].name, 'sorting_name');
    }
  }
  
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("click", this.handleTouch);

    this.startButtonAnimationLoop();
    this.setupElements();
    this._isSwipeAnimationActive = true;
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("click", this.handleTouch);
    window.removeEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
  }

  handleSwipeAnimation = (wrapperHeight, contentHeight) => {
    if (contentHeight > wrapperHeight && this._isSwipeAnimationActive) {
      clearTimeout(this._swipeAnimationTimerHandler);
      this._swipeAnimationTimerHandler = setTimeout(() => {
        this.setState({
          showGesture: true
        });
        setTimeout(() => {
          this.setState({
            showGesture: false
          });
        }, 3500);

        if (this._isSwipeAnimationActive) {
          this._swipeTimeout = 20000;
          this.handleSwipeAnimation(wrapperHeight, contentHeight);
        }
      }, this._swipeTimeout);
    } else {
      clearTimeout(this._swipeAnimationTimerHandler); 
    }
  }

  cancelSwipeAnimation = () => {
    this._isSwipeAnimationActive = false;
    clearTimeout(this._swipeAnimationTimerHandler);
  }

  setupElements = () => {
    let folderCategories = this.props.content.story_categories;
    let mainItem = this.createFolderTree(folderCategories);
    let items = mainItem.children;
    for (let i = 0; i < items.length; i++) {
      items[i].active = false;
      items[i].main = false;
      if (i === Math.ceil(items.length / 2)) {
        items[i].main = true;
      }
    }

    this._items = items;
  }

  createFolderTree = (categories, parent) => {
    if (shared.nullOrUndefined(parent)) {
      let main = _.find(categories, { name: "Main" });
      let children = this.createFolderTree(categories, main);
      main.children = children;
      return main;
    } else {
      let children = _.filter(categories, { parent_category: parent.id });
      if (children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          children[i].children = this.createFolderTree(categories, children[i]);
        }
        return children;
      } else {
        let modules = [];
        let folderFolderModules = _.filter(this.props.content.folder_modules, { folder: parent.id });
        let stories = [];
        let displayModules = [];
        let donors = [];
        
        _.forEach(folderFolderModules, fm => {
          switch (fm.model) {
            case "display_module":
              let dm = _.find(this.props.content.dm_active, { id: fm.module_id });
              if (dm) {
                dm.folder_module = fm;
                displayModules.push(dm);
              }
            break;
            case "story":
            let story = _.find(this.props.content.stories, { id: fm.module_id });
            if (story) {
                story.folder_module = fm;
                stories.push(story);
              }
            break;
            case "donor":
              let donor = _.find(this._allDonors, { id: fm.module_id });
              if (donor) {
                donor.folder_module = fm;
                donors.push(donor);
              }
            break;
            default:
            break;
          }
        });

        if (donors.length > 0) {
          modules = modules.concat(donors);
        }

        if (stories.length > 0) {
          modules = modules.concat(stories);
        }

        if (displayModules.length > 0) {
          modules = modules.concat(displayModules);
        }

        return modules;
      }
    }
  }

  getScreensNumber = () => {
    try {
      return this.props.content.settings.display_blocks[0].screens.length
    } catch (e) {
      return 1;
    }
  }

  showBezelHandle = (xScreens, yScreens) => {
    if (this.state.showDebug === false) {
      return (
        null
      )
    }

    let debugBoxStyle = {
      position: 'absolute',
      opacity: .7,
      backgroundColor: "black"
    }

    // Determine Horizontal Lines based on amount of V Screens.
    let hLines = Array.apply(null, { length: (yScreens + 1) }).map(Number.call, Number);
    let vLines = Array.apply(null, { length: (xScreens + 1) }).map(Number.call, Number);

    let regionHeight = this.props.screen.screenHeight / yScreens;
    let regionWidth = this.props.screen.screenWidth / xScreens;
    let bezel = this.props.screen.screenHeight * .005;

    let renderedHlines = hLines.map((lNumber, key) => {
      let bezelOffset = lNumber > 0 ? bezel / 2 : 0;
      bezelOffset = lNumber === (hLines.length - 1) ? bezel : bezelOffset;
      let style = {
        top: lNumber * regionHeight - bezelOffset,
        left: 0,
        height: bezel,
        width: this.props.screen.screenWidth
      }

      return (
        <div key={key} style={{ ...debugBoxStyle, ...style }}></div>
      );
    });

    let renderedVlines = vLines.map((lNumber, key) => {
      let bezelOffset = lNumber > 0 ? bezel / 2 : 0;
      bezelOffset = lNumber === (vLines.length - 1) ? bezel : bezelOffset;
      let style = {
        left: lNumber * regionWidth - bezelOffset,
        top: 0,
        width: bezel,
        height: this.props.screen.screenHeight
      }

      return (
        <div key={key} style={{ ...debugBoxStyle, ...style }}></div>
      );
    });

    return (
      <div>
        {renderedVlines}
        {renderedHlines}
      </div>
    );
  }

  goIdle = (type) => {
    if (type === "recentInteraction") {
      this.setState({
        recentInteraction: false,
      });
    }
    else {
      this.setupElements();
      if (this._attractLoopTree.children[0]) {
        this._menuActive = false;
        this.setState({
          idle: true,
          contentOnScreen: false,
          menuOnScreen: false
        });
        this.cycleIdle();
        this.cycleIdleLoop();
      }
    }
  }

  getMenuCoordinates = (x, y) => {
    let regionWidth = this.props.screen.screenWidth / this._xScreens;
    let regionHeight = this.props.screen.screenHeight / this._yScreens;
    let regionX = Math.floor(x / regionWidth);
    let regionY = Math.floor(y / regionHeight);

    let coordinates = {
      x: this._menuOriginalCoordinates.x + (regionWidth * regionX),
      y: this._menuOriginalCoordinates.y + (regionHeight * regionY)
    }

    return coordinates;
  }

  getContentCoordinates = (x, y) => {
    let regionWidth = this.props.screen.screenWidth / this._xScreens;
    let regionHeight = this.props.screen.screenHeight / this._yScreens;
    let regionX = Math.floor(x / regionWidth);
    let regionY = Math.floor(y / regionHeight);

    let coordinates = {
      x: regionWidth * regionX,
      y: regionHeight * regionY,
      regionX: regionX,
      regionY: regionY
    }

    return coordinates;
  }

  resume = () => {
    if (this.state.idle === true) {
      this._startButtonRef.animate([
        {
          transform: "scale(1.0)"
        },
        {
          transform: "scale(0.9)"
        }
      ], {
          fill: "forwards",
          duration: 25
        })
      this.setState({
        buttonPressed: true
      });

      setTimeout(() => {
        this._swipeTimeout = 5000;
        this._isSwipeAnimationActive = true;
        this.props.history.replace('/seattle');
        this.setState({
          idle: false,
          buttonPressed: false
        })
        clearTimeout(this._idleLoopTimeout);
      }, 250)
    }
    if (this.state.recentInteraction === false) {
      this.setState({
        recentInteraction: true
      });
    }
  }

  cycleIdle = () => {
    if (this._attractLoopTree && this._attractLoopTree.children.length > 0) {
      try {
  
        if (this.idleRef >= this._attractLoopTree.children.length) {
          this.idleRef = 0;
        }
    
        let type = _.get(this._attractLoopTree.children[this.idleRef].contents, 'custom_fields.story_type.val.value', 'story');
        let moduleId = this._attractLoopTree.children[this.idleRef].id;
        this.navroute(this.idleRef, type, "idle", { idleModule: moduleId, idleRef: this.idleRef });
      } catch(e) {
        console.log(e);
      }
    }
  }

  cycleIdleLoop = () => {
    try {
      clearTimeout(this._idleLoopTimeout);
      let timeout = Number(_.get(this._attractLoopTree.children[this.idleRef].contents, 'custom_fields.slide_cycle_time.val', 30));
      this._idleLoopTimeout = setTimeout(() => {
        this.cycleIdle();
        this.cycleIdleLoop();
      }, timeout * 1000);
      this.idleRef++;
    } catch(e) {
      console.log(e);
    }
  }

  manualCycle = (direction) => {
    clearTimeout(this._idleLoopTimeout);
    this.idleRef = shared.loopIndex(this.idleRef - 1, 0, this._attractLoopTree.children.length - 1, direction);
    let type = _.get(this._attractLoopTree.children[this.idleRef].contents, 'custom_fields.story_type.val.value', 'story');
    let moduleId = this._attractLoopTree.children[this.idleRef].id;
    this.navroute(this.idleRef, type, "idle", { idleModule: moduleId, idleRef: this.idleRef });
    this.cycleIdleLoop();
  }

  // cycleIdle = () => {
  //   if (this.idleRef >= this.props.content.display_module_loops[0].display_module_loop_units.length) {
  //     this.idleRef = 0
  //   }

  //   this.navroute(this.idleRef, this.props.content.display_module_loops[0].display_module_loop_units[this.idleRef].data.display_module_type, "idle", { idleModule: this.idleRef });
  // }

  // cycleIdleLoop = () => {
  //   clearTimeout(this._idleLoopTimeout);
  //   this._idleLoopTimeout = setTimeout(() => {
  //     this.cycleIdle();
  //     this.cycleIdleLoop();
  //   }, this.props.content.display_module_loops[0].display_module_loop_units[this.idleRef].cycle_time_seconds * 1000);
  //   this.idleRef++;
  // }

  navroute = (ref, type, source, options) => {
    //console.log("NAVROUTE", ref, type, source, options);
    if (ref === null) {
      if (this.props.active_module !== undefined) {
        ref = this.props.active_module //maintain module if not changed
      }
    }
    if (type === null) {
      type = this.getActiveModuleType();
    }
    // this.toggleSlideOff();
    this.setState({
      displayNav: false,
      options: options
    });
    this.props.setOptions(options);
    this.props.switchModule(ref);
    switch (type) {
      case "checkerboard":
        this.setState({ showNav: true });
        if (source === "idle") {
          let url = "/seattle/checkerboard?id=" + options.idleRef; //ensures unique path
          this.props.history.replace(url);
        }
        else {
          this.props.history.replace("/seattle/checkerboard?id=" + ref);
        }
        break;
      default:
        break;
    }

    if (options && options.routeoverride !== undefined && options.routeoverride !== null) {
      this.props.history.replace(options.routeoverride);
    }
  }

  // navroute = (ref, type, source, options) => {
  //   //console.log("NAVROUTE", ref, type, source, options);
  //   if (ref === null) {
  //     if (this.props.active_module !== undefined) {
  //       ref = this.props.active_module //maintain module if not changed
  //     }
  //   }
  //   if (type === null) {
  //     type = this.getActiveModuleType();
  //   }
  //   // this.toggleSlideOff();
  //   this.setState({
  //     displayNav: false,
  //     options: options
  //   });
  //   this.props.setOptions(options);
  //   this.props.switchModule(ref);
  //   switch (type) {
  //     case "Story":
  //       this.setState({ showNav: true });
  //       if (source === "idle") {
  //         let url = "/seattle/checkerboard?id=" + options.idleModule; //ensures unique path
  //         this.props.history.replace(url);
  //       }
  //       else {
  //         this.props.history.replace("/seattle/checkerboard?id=" + ref);
  //       }
  //       break;
  //     default:
  //       break;
  //   }

  //   if (options && options.routeoverride !== undefined && options.routeoverride !== null) {
  //     this.props.history.replace(options.routeoverride);
  //   }
  // }

  handleKeyDown = (event) => {
    switch (event.key) {
      case "ArrowLeft":
        if (this.props.screen.mode === "preview") {
          this.manualCycle("backward");          
        }
      break;
      case "ArrowRight":
        if (this.props.screen.mode === "preview") {
          this.manualCycle("forward");
        }
      break;
      case "s":
        console.log(this.props);
        break;
      case "n":
        this.openNav();
        break;
      case "d":
        this.setState({
          showDebug: !this.state.showDebug
        });
        break;
      default:
        break;
    }
  }

  isEventOnSameRegion = (newCoordX, newCoordY, lastCoordX, lastCoordY) => {
    let regionWidth = this.props.screen.screenWidth / this._xScreens;
    let regionHeight = this.props.screen.screenHeight / this._yScreens;
    let newRegionX = Math.floor(newCoordX / regionWidth);
    let newRegionY = Math.floor(newCoordY / regionHeight);
    let lastRegionX = Math.floor(lastCoordX / regionWidth);
    let lastRegionY = Math.floor(lastCoordY / regionHeight);

    return newRegionX === lastRegionX && newRegionY === lastRegionY;
  }

  handleTouch = (event, regionChanged) => {
    if (regionChanged === undefined) {
      regionChanged = false;
    }

    if (!this.state.idle) {
      if (this.state.menuOnScreen) {
        // If menu is already on screen
        const { clientX, clientY } = event;
        if (!this.isEventOnSameRegion(clientX, clientY, this.state.touchScreenX, this.state.touchScreenY)) {
          this._clickLocked = STAGE_ONE_LOCKED;
          this.setState({
            menuOnScreen: false,
            contentOnScreen: false,
            content: null
          });
          clearTimeout(this._menuTimeoutHandler);
          this._menuTimeoutHandler = null;
          this._menuTimeoutHandler = setTimeout(() => {
            this._clickLocked = STAGE_TWO_LOCKED;
            this.handleTouch(event, true);
          }, 500);
        }
      } else {
        if (this._clickLocked === STAGE_TWO_LOCKED || this._clickLocked === RELEASED) {
          const { clientX, clientY } = event;
          let contentOnScreen = this._menuActive;
          let coordinates = this.getMenuCoordinates(clientX, clientY);
          let contentCoordinates = this.getContentCoordinates(clientX, clientY);
          let activateBubble = false;
          let activateListMenu = false;
          this._clickLocked = RELEASED;

          let activeItem = _.find(this._items, { active: true });
          if (activeItem) {
            if (activeItem.children && activeItem.children.length > 0) {
              if (activeItem.children[0].folder_module) {
                this.handleContentChange(activeItem.id, null, null, null);
              } else {
                let menuPathType = this.getMenuPathType(activeItem, 0);
                
                if (menuPathType === 1) {
                  activateBubble = true;
                  this.handleContentChange(activeItem.id, activeItem.children[0].id);
                }

                if (menuPathType >= 2) {
                  activateBubble = true;
                  activateListMenu = true;
                  this.handleContentChange(activeItem.id, activeItem.children[0].id, 0, 0);
                }
              }
            }
          }

          this.setState({
            menuOnScreen: true,
            activateBubble: activateBubble,
            activateListMenu: activateListMenu,
            contentOnScreen: contentOnScreen,
            touchScreenX: coordinates.x,
            touchScreenY: coordinates.y,
            contentX: contentCoordinates.x,
            contentY: contentCoordinates.y,
            regionX: this.state.regionX,
            regionY: this.state.regionY,
          });
        }
      }
    } else {
      setTimeout(() => {
        this.handleTouch(event, null);
      }, 750);
    }
  }

  getMenuPathType(item, count) {
    if (item.children && item.children.length > 0) {
      let children = _.orderBy(item.children, ['rank'], ['asc']);
      if (children[0].folder_module) {
        return count;
      } else {
        count++;
        return this.getMenuPathType(children[0], count);
      }
    } else {
      return count;
    }
  }

  isContent(obj) {
    if (obj && obj.children && obj.children.length > 0 && obj.children[0].folder_module) {
      return true;
    }
    return false;
  }

  handleContentChange = (mainItemId, bubbleId, listItemArrayIndex, listItemChildIndex) => {
    try {
      let mainItem = _.find(this._items, { id: mainItemId });
      let content = null;
      if (mainItem.children[0].folder_module) {
        content = mainItem;
      } else {
        let bubbleItem = _.find(mainItem.children, { id: bubbleId });
        let sortedItems = _.orderBy(bubbleItem.children, 'rank', 'asc')
        let listItem = sortedItems[listItemArrayIndex]
    
        let listItemChild;
        if (this.isContent(listItem)) {
          content = listItem
        }
    
        if (!shared.nullOrUndefined(listItemChildIndex)) {
          if (bubbleItem.children && bubbleItem.children.length > 0) {
            let childrenSorted = _.orderBy(listItem.children, 'rank', 'asc')
            listItemChild = childrenSorted[listItemChildIndex]
            if (this.isContent(listItemChild)) {
              content = listItemChild
            }
          }
        }
        else if (!shared.nullOrUndefined(listItemArrayIndex)) {
          if (listItem.children && listItem.children.length > 0) {
            let childrenSorted = _.orderBy(listItem.children, 'rank', 'asc');
            listItemChild = childrenSorted[0];
            if (this.isContent(listItemChild)) {
              content = listItemChild
            }
          }
          
        }
        else {
          if (this.isContent(bubbleItem)) {
            content = bubbleItem;
          }
        }  
      }
  
      this.setState({
        content: content
      });
    } catch(e) {
      console.log(e);
    }
  }

  storeMenuStatus = (status, id) => {
    this._menuActive = status;
    let activeElement = _.find(this._items, { id: id });
    for (let i = 0; i < this._items.length; i++) {
      if (this._items[i].id === id) {
        this._items[i].main = true;
        this._items[i].active = true;
      } else {
        this._items[i].main = false;
        this._items[i].active = false;
      }
    }
    let background = this.getBackground(activeElement);
    this.setState({
      content: null,
      contentOnScreen: this._menuActive,
      contentBackgroundColor: activeElement.contents.custom_fields.background_color.val,
      background: background
    });
  }

  startButtonAnimationLoop = () => {
    clearTimeout(this._startButtonTimeout);
    this._startButtonTimeout = setTimeout(() => {
      if (this._startButtonRef) {
        this._startButtonRef.animate([
          {
            transform: "scale(1)",
          },
          {
            transform: "scale(1.1)",
          },
          {
            transform: "scale(1)",
          },
        ], {
          fill: "forwards",
          duration: 750
        });
      }
      this.startButtonAnimationLoop();
    }, 6000)
  }

  getBackground = (activeElement) => {
    if (!activeElement) {
      let displayImage = _.get(this.props.content.settings, 'lower_layer_file', null);
      return shared.dp(this.props.screen, displayImage, null);
    }

    let slideshowName = _.get(this.props.content.settings, 'custom_vars.Slideshow', null);
    let background = null;
    if (slideshowName) {
      let slideshow = _.find(this.props.content.dm_active, { name: slideshowName });
      if (slideshow) {
        let slideIndex = _.findIndex(slideshow.contents.names, (name) => {
          return name === activeElement.name;
        });
        if (slideIndex > -1) {
          let img = slideshow.contents.images[slideIndex];
          background = shared.dp(this.props.screen, img, null);
        }
      }
    }

    return background;
  }

  setAttractLoopBackground = (backgroundUrl) => {
    this.setState({
      attractLoopBackground: backgroundUrl
    });
  }

  render() {
    const { location } = this.props;
    const key = this.props.location.pathname + this.props.location.search;
    // let buttonPressedStyle = {}
    // if (this.state.buttonPressed) {
    //   buttonPressedStyle = {
    //     boxShadow: "inset 0 4px 35px rgba(0, 0, 0, 1)"
    //   }
    // }

    // let bubbleDiameter = this.props.screen.screenWidth * TOUCH_START_BUBBLE_DIAMETER / 100;
    // let touchToStartStyle = {
    //   width: bubbleDiameter,
    //   height: bubbleDiameter,
    //   borderRadius: "50%",
    //   backgroundColor: "white",
    //   opacity: 0.65
    // }

    return (
      <div>
        <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='fastfadedelay'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          {
            !this.state.idle ?
              <div key={this.state.background} style={{ position: "absolute", backgroundImage: `url(${this.state.background})`, backgroundSize: `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`, height: this.props.screen.screenHeight, width: this.props.screen.screenWidth }}></div>
              : null
          }
        </CSSTransitionGroup>

        <div className={this.props.content.font_class} style={{ color: this.props.content.settings.main_font_color, backgroundColor: "white", height: this.props.screen.screenHeight, width: this.props.screen.screenWidth }}>
          <CSSTransitionGroup
            component='div'
            className="fastfadedelay"
            style={{ minHeight: '100%' }}
            transitionName='fastfadedelay'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <Switch key={key} location={location}>
              <Route path='/seattle/checkerboard' render={props => <CheckerboardSeattle {...props} xScreens={3} yScreens={2} idle={this.state.idle} setCurrentBackground={this.setAttractLoopBackground} />} />
            </Switch>
          </CSSTransitionGroup >
          
          {/* Content */}
          <CSSTransitionGroup
            component='div'
            className="fastfadedelay"
            style={{ minHeight: '100%' }}
            transitionName='example'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.contentOnScreen}>
              {
                this.state.contentOnScreen ?
                  <ContentSeattle
                    screen={this.props.screen}
                    backgroundColor={this.state.contentBackgroundColor}
                    regionWidth={this.props.screen.screenWidth / this._xScreens}
                    regionHeight={this.props.screen.screenHeight / this._yScreens}
                    contentX={this.state.contentX}
                    contentY={this.state.contentY}
                    content={this.state.content}
                    handleSwipeAnimation={this.handleSwipeAnimation}
                    cancelSwipeAnimation={this.cancelSwipeAnimation}
                  />
                  : null
              }
            </div>
          </CSSTransitionGroup>

          {/* Touch Gesture */}
          {
            this.state.contentOnScreen ?
            <TouchGestureSeattle
              screen={this.props.screen}
              regionWidth={this.props.screen.screenWidth / this._xScreens}
              regionHeight={this.props.screen.screenHeight / this._yScreens}
              contentX={this.state.contentX}
              contentY={this.state.contentY}
              show={this.state.showGesture}
            />
            : null
          }

          <CSSTransitionGroup
            component='div'
            className="fastfadedelay"
            style={{ minHeight: '100%' }}
            transitionName='example'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            {/* Main Menu */}
            <div key={this.state.menuOnScreen}>
              {
                this.state.menuOnScreen ?
                  <MenuSeattle
                    screenX={this.state.touchScreenX}
                    screenY={this.state.touchScreenY}
                    screen={this.props.screen}
                    mainItemCoordinates={this._menuOriginalCoordinates}
                    regionWidth={this.props.screen.screenWidth / this._xScreens}
                    regionHeight={this.props.screen.screenHeight / this._yScreens}
                    items={this._items}
                    storeMenuStatus={this.storeMenuStatus}
                    menuActive={this._menuActive}
                    contentX={this.state.contentX}
                    contentY={this.state.contentY}
                    regionX={this.state.regionX}
                    regionY={this.state.regionY}
                    changeContent={this.handleContentChange}
                    activateBubble={this.state.activateBubble}
                    activateListMenu={this.state.activateListMenu}
                  />
                  : null
              }
            </div>
          </CSSTransitionGroup>

          {/* Touch to start */}
          {
            this.state.idle ?
              <div style={{ position: "absolute", height: this.props.screen.screenHeight, width: this.props.screen.screenWidth, top: 0, left: 0, display:"flex", alignItems:"center", justifyContent:"center" }}>
                <img ref={el => this._startButtonRef = el} src="/img/seattle/general/start.png" style={{ opacity:"0.65", width:"25vh" }} alt=""/>
              </div>
              : null
          }

          {/* Show Screens Bezel */}
          <div key={this.state.showDebug}>
            {this.showBezelHandle(this._xScreens, this._yScreens)}
          </div>

          {/* Idle Loop */}
          {
            this.props.idleActive === true && this._attractLoopTree.children && this._attractLoopTree.children.length > 0 ?
              <div>
                <IdleLoop
                  idle_delay={this.props.content.idle_delay}
                  goIdle={this.goIdle}
                  resume={this.resume}
                />

              </div>
              :
              null
          }
        </div >
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  let active_module = state.active_module
  let idle = shared.parseStringParam(window.location.href, "idle");
  let namedmodule = shared.parseStringParam(window.location.href, "name");
  let hScreens = shared.parseStringParam(window.location.href, "hscreens");
  let vScreens = shared.parseStringParam(window.location.href, "vscreens");

  // let idleActive = false;
  let idleActive = true;
  if (state.content.idle_delay === 0 || idle === "false") {
    idleActive = false;
  }

  if (namedmodule) {
    active_module = _.findIndex(state.content.dm_active, { name: decodeURIComponent(namedmodule) });
  }

  if (hScreens === undefined || hScreens === null) {
    hScreens = 3;
  }

  if (vScreens === undefined || vScreens === null) {
    vScreens = 2;
  }

  return {
    active_module: active_module,
    content: state.content,
    contentHasErrored: state.contentHasErrored,
    contentIsLoading: state.contentIsLoading,
    donors: state.donors,
    donorsHasErrored: state.donorsHasErrored,
    donorsIsLoading: state.donorsIsLoading,
    screen: state.screen,
    options: state.options,
    screensNumber: state.screensNumber,
    idleActive: idleActive,
    displayLayout: {
      horizontal: hScreens,
      vertical: vScreens
    }
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    switchModule: (id) => dispatch(switchModule(id)),
    setOptions: (data) => dispatch(setOptions(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SeattleContainer);


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/SeattleContainer.jsx